/**
 * ClickUp Priority.
 */
export enum ClickUpPriority {
	Urgent = 1,
	High = 2,
	Normal = 3,
	Low = 4
}
